import { render } from "./kalio-form-wrapper.vue?vue&type=template&id=5369b8c5"
import script from "./kalio-form-wrapper.vue?vue&type=script&lang=js"
export * from "./kalio-form-wrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__